import React, { useEffect, useRef, useState } from 'react';
import { StyleSheet, Text, TextInput as RNTextInput, View } from 'react-native';

import {
  useConsumerQuery,
  useConfirmAuthVerificationMutation,
  useInitiateAuthVerificationMutation,
} from 'apollo/queries/autogenerate/hooks';
import {
  AuthVerificationScope,
  PinCodeDispatchMethod,
} from 'apollo/queries/autogenerate/schemas';
import CodeInput from 'shared/modules/common/components/atoms/CodeInput';
import OTPTimer from 'shared/modules/common/components/organisms/OTPTimer';

type Props = {
  onSuccess: () => void;
};

const EditUserProfileOTP = (props: Props) => {
  const { data } = useConsumerQuery({ fetchPolicy: 'cache-only' });
  const [
    initiateAuthVerificationMutation,
  ] = useInitiateAuthVerificationMutation();
  const [
    confirmAuthVerificationMutation,
  ] = useConfirmAuthVerificationMutation();
  const [showError, setShowError] = useState(false);
  const codeInputRef = useRef<RNTextInput>(null);

  const focusCodeInput = () => codeInputRef.current?.focus();

  const resendOTPToConsumer = () => {
    initiateAuthVerificationMutation({
      variables: {
        pinCodeDispatchMethod: PinCodeDispatchMethod.VOICE,
        scope: AuthVerificationScope.UPDATE_CONSUMER_INFO,
      },
    });

    focusCodeInput();
  };

  const submitOTP = async (otp: string) => {
    setShowError(false);

    try {
      await confirmAuthVerificationMutation({
        variables: {
          otp,
          scope: AuthVerificationScope.UPDATE_CONSUMER_INFO,
        },
      });

      props.onSuccess();
    } catch (err) {
      setShowError(true);
    }
  };

  useEffect(focusCodeInput, []);

  return (
    <View style={style.root}>
      <View>
        <View style={style.marginBottom}>
          <Text style={[style.textTitle, style.marginBottom]}>
            認証コード入力
          </Text>
          <Text>
            {data?.consumer.phone}
            に送信された4桁の認証コードを入力してください。
          </Text>
        </View>
        <View style={style.otp}>
          <CodeInput
            onFulFill={submitOTP}
            style={style.codeField}
            errorMessage="認証コードに誤りがあります"
            showError={showError}
            id="edit-user-profile-code-field"
            ref={codeInputRef}
          />
        </View>
      </View>
      <OTPTimer sentToLabel="自動音声案内" onPress={resendOTPToConsumer} />
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'space-between',
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24,
  },
  otp: {
    alignItems: 'center',
  },
  codeField: {
    width: 288,
  },
  marginBottom: {
    marginBottom: 24,
  },
});

export default EditUserProfileOTP;
